import { useEffect, useState } from 'react';
import { useUniversalContext } from '@cxc/react-universal-components';
import {
  constructDigitalData,
  fireAnalyticsEvent,
  fireAnalyticsOnPageLoad,
  getCookiePreferences,
  getDataForPageEvent,
  logAnalytics,
} from './helpers';
import { MARKET_DIGITALDATA_MAP, PAGE_LOAD_EVENT } from './analytics.constants';
import { AnalyticsEvent, defaultDigitalData } from './defaultDigitalData';
import { isEULanguage } from '../utils/locale';

const useAnalytics = (pageName: string, eventName?: string, fileId?: string) => {
  const { subscribeScopedValue, language, isLoggedIn } = useUniversalContext();
  const cookiePreferences = subscribeScopedValue('fpg_cookies', 'cookiePreferences');
  const isAnalyticsLoaded = subscribeScopedValue('fpg_analytics', 'isLoaded');
  const [analyticsValue, setAnalyticsValue] = useState<AnalyticsEvent>(null);
  const digitalData = defaultDigitalData;
  digitalData.page.userLanguage = MARKET_DIGITALDATA_MAP[language].lang;
  digitalData.page.client = MARKET_DIGITALDATA_MAP[language].client;
  digitalData.page.country = MARKET_DIGITALDATA_MAP[language].client;
  digitalData.page.site = MARKET_DIGITALDATA_MAP[language].site;

  useEffect(() => {
    if (!analyticsValue && pageName) {
      const pageEventBaseData = getDataForPageEvent(pageName, PAGE_LOAD_EVENT);
      const updates = [
        {
          propertyDescriptor: 'user.loginStatus',
          value: `logged ${isLoggedIn ? 'in' : 'out'}`,
        },
        {
          propertyDescriptor: 'page.userLanguage',
          value: MARKET_DIGITALDATA_MAP[language].lang,
        },
      ];
      if (cookiePreferences && isEULanguage(language)) {
        updates.push({
          propertyDescriptor: 'user.optInStatus',
          value: getCookiePreferences(cookiePreferences),
        });
      }
      const pageEventData: AnalyticsEvent = {
        ...pageEventBaseData,
        digitalDataProperties: [...pageEventBaseData.digitalDataProperties, ...updates],
      };
      setAnalyticsValue(pageEventData);
    }
  }, [isLoggedIn, language]);

  useEffect(() => {
    if (analyticsValue && isAnalyticsLoaded) {
      logAnalytics(PAGE_LOAD_EVENT);
      const { digitalData, directCallName } = constructDigitalData(analyticsValue);
      if (cookiePreferences && isEULanguage(language)) {
        digitalData.user.optInStatus = getCookiePreferences(cookiePreferences);
      }

      if (fileId === 'skip') {
        console.log(`skip Analytics Event :- PAGE_LOAD`);
      } else if (fileId) {
        fireAnalyticsOnPageLoad(analyticsValue, pageName, eventName as string, fileId);
      } else {
        fireAnalyticsEvent(digitalData, directCallName);
      }
    }
  }, [analyticsValue, isAnalyticsLoaded]);

  return analyticsValue;
};

export default useAnalytics;
